function l(l) {
  return null === l;
}
export { l as default };